export default __webpack_public_path__ + "static/mockCalendar1-c18d293fa4995d895bc08ce838b551ee.png";